/**
 * Le contrat des signalements de problème en live, côté client.
 *
 * Ces valeurs voyagent jusqu'au backend, qui les valide contre
 * `App\Enums\IssueReportSource` et sa liste de catégories. Elles étaient écrites
 * en dur des deux côtés de la frontière, et le backend accepte `source` comme
 * facultatif : une faute de frappe ne renvoyait donc pas d'erreur, elle
 * dégradait silencieusement une alerte automatique en signalement manuel —
 * plus de déduplication, un des trois signalements de l'élève consommé, et un
 * message qui part dans le mauvais canal sans mention.
 */

export const ISSUE_REPORT_SOURCE = {
    /** Écrit à la main par l'utilisateur, depuis « signaler un problème ». */
    MANUAL: "manual",
    /** Émis par le test matériel d'entrée au live, sans que personne n'écrive. */
    PRECALL_CHECK: "from_precall_check",
}

/** Les catégories acceptées par l'endpoint de signalement. */
export const ISSUE_REPORT_CATEGORY = {
    AUDIO: "audio",
    VIDEO: "video",
    CONNECTION: "connection",
    SCREEN_SHARE: "screen_share",
    CONTENT: "content",
    OTHER: "other",
}
